import { useMutation } from "@tanstack/react-query"

import type { UseCaseFormData } from "../types/use-case.types"

import { aiClaudePrompt } from "../api/use-cases-api"

export function useAiClaudePrompt() {
  return useMutation({
    mutationFn: (useCaseData: Partial<UseCaseFormData>) => aiClaudePrompt(useCaseData),
  })
}
